import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import styles from './styles.module.css';
import spanish from '../../../../../../../common/language/spanis';
import english from '../../../../../../../common/language/english';
import layout from '../../../../../../../common/layout';

let lang = spanish;

class UserReserver extends Component {
    componentWillMount() {
        const {language}= this.props;
        if (language === 'spanish') {
            lang = spanish;
        }
        else {
            lang = english;
        }
    }
    render() {
        const {owner, phone, email } = this.props.state;
        return (
            <div>
                <h3>{lang.form.userReserver.title}</h3>
                {/* 
                ====================================
                Nombre
                ====================================
                */}
                <TextField
                    id="owner"
                    className={styles.city}
                    variant="outlined"
                    label={lang.form.userReserver.inputName}
                    value={owner}
                    onChange={this.props.handleChange('owner')}
                />
                <div className={styles.rowContainer} >
                    <div style={{ flex: 0.5, paddingRight: 5 }}>
                        {/* 
                        ====================================
                        Telefono
                        ====================================
                        */}
                        <TextField
                            id="phone"
                            className={styles.city}
                            variant="outlined"
                            label={lang.form.userReserver.inputPhone}
                            value={phone}
                            onChange={this.props.handleChange('phone')}
                        />
                    </div>
                    <div style={{ flex: 0.5, paddingLeft: 5 }}>
                        {/* 
                        ====================================
                        Correo
                        ====================================
                        */}
                        <TextField
                            id="email"
                            className={styles.city}
                            variant="outlined"
                            label={lang.form.userReserver.inputEmail}
                            value={email}
                            onChange={this.props.handleChange('email')}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => ({
    language: state.LanguageReducer.language,
  });
  
  const mapDispatchToProps = dispatch => ({

  });
  
  // make this component available to the app
  export default connect(mapStateToProps, mapDispatchToProps)(UserReserver);
  
  